import moment from 'moment';

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'

export const intervalHumanizer = (interval: number) => {
  let secondInterval = interval / 1000;
  if (secondInterval > 24 * 3600) {
    return { val: Math.ceil(secondInterval / (24 * 3600)), unit: 'day' }
  } else if (secondInterval > 3600) {
    return { val: (secondInterval / 3600).toFixed(0), unit: 'hour' }
  } else if (secondInterval > 60) {
    return { val: (secondInterval / 60).toFixed(0), unit: 'minute' }
  } else {
    return { val: secondInterval.toFixed(0), unit: 'second' }
  }
}

export default {
  intervalHumanizer
}
// disable if val < comVal
export const disabledDate = (val: any, compVal: any) => {
  if (!val || !moment(val).isValid()) {
    return false;
  }
  if (!compVal || !moment(compVal).isValid()) {
    return false;
  }
  if(typeof val !== 'object') {
    val = moment(val)
  }
  if(typeof compVal !== 'object') {
    compVal = moment(compVal)
  }
  val = val.format("YYYY-MM-DD")
  compVal = compVal.format("YYYY-MM-DD")
  return val < compVal
}